import React from 'react'
import { FormattedMessage } from 'react-intl'


export const SCHEDULE_TITLE = (
    <FormattedMessage
        id='schedule.title'
        defaultMessage='Расписание сражнений'
    />
)

export const SCHEDULE_TOOLTIP = (
    <FormattedMessage
        id='schedule.tooltip'
        defaultMessage='Нажмите, чтобы перейти к расписанию сражений в Укрепрайоне.'
    />
)

export const SCHEDULE_HAS_CHANGES = (
    <FormattedMessage
        id='schedule.has_changes'
        defaultMessage='Есть изменения в расписании.'
    />
)


// WEBPACK FOOTER //
// ./containers/Schedule/shared_translations.jsx